import { nextTick, Ref } from 'vue'

export const useHeightComposable = (
  heightState: Ref<number>,
  componentRef: Ref<HTMLElement | HTMLElement[]>
) => {
  let resizeObserver: ResizeObserver | null = null
  let observerRef: any = null

  const observerWatcher = async (newValue: any) => {
    if (newValue) {
      unmountObserver()
      await mountObserver()
    } else {
      unmountObserver()
    }
  }

  const getObserverRef = (): HTMLElement => {
    if (componentRef.value instanceof Array) {
      return componentRef.value[0] as HTMLElement
    }
    return componentRef.value
  }

  const mountObserver = async () => {
    await nextTick()
    if (componentRef.value) {
      observerRef = getObserverRef()
      resizeObserver = new ResizeObserver(() => {
        heightState.value = observerRef?.$el?.offsetHeight || 0
      })
      resizeObserver.observe(observerRef.$el)
    }
  }

  const unmountObserver = () => {
    observerRef = getObserverRef()
    if (resizeObserver && observerRef) {
      resizeObserver.unobserve(observerRef.$el)
      resizeObserver.disconnect()
      resizeObserver = null
    }
  }

  return {
    mountObserver,
    observerWatcher,
    unmountObserver
  }
}
